import { connectedAccountsStore } from '../store/store';
import getOAuth2AuthorizationEndpointInfoOperation from 'owa-service/lib/operation/getOAuth2AuthorizationEndpointInfoOperation';
import GetOAuth2AuthorizationEndpointRequest from 'owa-service/lib/contract/GetOAuth2AuthorizationEndpointRequest';
import GetOAuth2AuthorizationEndpointResponse from 'owa-service/lib/contract/GetOAuth2AuthorizationEndpointResponse';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export async function getAuthorizationUri(): Promise<GetOAuth2AuthorizationEndpointResponse> {
    const provider: number = 4;
    const uri: string = `${window.location.protocol}//${
        window.location.hostname
    }/mail/GetAuthorizationCode.html`;

    let store = connectedAccountsStore();
    let state: string = btoa(
        JSON.stringify({
            provider: 'google',
            trf: store.connectGmailState.targetRootFolderEnabled ? 1 : 0,
            sendonly: store.connectGmailState.isSendOnly ? 1 : 0,
            displayname: store.connectGmailState.displayName,
        })
    );

    let request: GetOAuth2AuthorizationEndpointRequest = {
        Header: getJsonRequestHeader(),
        OAuthProvider: provider,
        RedirectUri: uri,
        State: state,
    };

    let response: GetOAuth2AuthorizationEndpointResponse = await getOAuth2AuthorizationEndpointInfoOperation(
        request
    );

    return response;
}
